import React, { useState, useEffect } from "react";
import { BiDownArrowAlt } from "react-icons/bi";
import classes from "./ScrollToBottom.module.css";
import clsx from "clsx";

const ScrollToBottomButton = ({ className }) => {
  const [isAtBottom, setIsAtBottom] = useState(false);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  };

  const handleScroll = () => {
    const scrollPosition =
      window.innerHeight + document.documentElement.scrollTop;
    const documentHeight = document.documentElement.offsetHeight;
    // Check if the scroll position is at or near the bottom
    if (scrollPosition >= documentHeight - 10) {
      // Allow a small threshold
      setIsAtBottom(true);
    } else {
      setIsAtBottom(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    // Check initial scroll position on mount in case the page is already scrolled down
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    !isAtBottom && (
      <button
        className={clsx(classes.button, className)}
        onClick={scrollToBottom}
      >
        <BiDownArrowAlt />
      </button>
    )
  );
};

export default ScrollToBottomButton;
